const NoDataCard = ({
  message = "Adjust the date range or check back later for updated data.",
  heading = "No data found for this range!",
}: {
  message?: string;
  heading?: string;
}) => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col gap-[38px] items-center">
        <div>
          <svg
            width="187"
            height="150"
            viewBox="0 0 187 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z"
              fill="#EEEEE4"
            />
            <g filter="url(#filter0_d_26086_41741)">
              <path
                d="M41 34H176C177.326 34 178.598 34.5268 179.536 35.4645C180.473 36.4021 181 37.6739 181 39V64C181 65.3261 180.473 66.5979 179.536 67.5355C178.598 68.4732 177.326 69 176 69H41C39.6739 69 38.4021 68.4732 37.4645 67.5355C36.5268 66.5979 36 65.3261 36 64V39C36 37.6739 36.5268 36.4021 37.4645 35.4645C38.4021 34.5268 39.6739 34 41 34V34Z"
                fill="white"
              />
            </g>
            <path
              d="M105 42H79C77.3431 42 76 43.3431 76 45C76 46.6569 77.3431 48 79 48H105C106.657 48 108 46.6569 108 45C108 43.3431 106.657 42 105 42Z"
              fill="#021859"
            />
            <path
              d="M123 55H79C77.3431 55 76 56.3431 76 58C76 59.6569 77.3431 61 79 61H123C124.657 61 126 59.6569 126 58C126 56.3431 124.657 55 123 55Z"
              fill="#EEEEE4"
            />
            <path
              d="M68 51.5C68 43.4919 61.5081 37 53.5 37C45.4919 37 39 43.4919 39 51.5C39 59.5081 45.4919 66 53.5 66C61.5081 66 68 59.5081 68 51.5Z"
              fill="#021859"
            />
            <path
              d="M57.9593 57.3999V50.1999M53.6393 57.3999V45.8799M49.3193 57.3999V53.0799"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g filter="url(#filter1_d_26086_41741)">
              <path
                d="M161 79H26C23.2386 79 21 81.2386 21 84V109C21 111.761 23.2386 114 26 114H161C163.761 114 166 111.761 166 109V84C166 81.2386 163.761 79 161 79Z"
                fill="white"
              />
            </g>
            <path
              d="M90 87H64C62.3431 87 61 88.3431 61 90C61 91.6569 62.3431 93 64 93H90C91.6569 93 93 91.6569 93 90C93 88.3431 91.6569 87 90 87Z"
              fill="#021859"
            />
            <path
              d="M108 100H64C62.3431 100 61 101.343 61 103C61 104.657 62.3431 106 64 106H108C109.657 106 111 104.657 111 103C111 101.343 109.657 100 108 100Z"
              fill="#EEEEE4"
            />
            <path
              d="M53 96.5C53 88.4919 46.5081 82 38.5 82C30.4919 82 24 88.4919 24 96.5C24 104.508 30.4919 111 38.5 111C46.5081 111 53 104.508 53 96.5Z"
              fill="#021859"
            />
            <path
              d="M32.1602 90.1599V103.12H45.1202M43.6802 94.4799L40.0802 98.0799L37.2002 95.1999L35.0402 97.3599"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <filter
                id="filter0_d_26086_41741"
                x="30"
                y="31"
                width="157"
                height="47"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="3" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_26086_41741"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_26086_41741"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_d_26086_41741"
                x="15"
                y="76"
                width="157"
                height="47"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="3" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_26086_41741"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_26086_41741"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div className="flex flex-col gap-[7px]">
          <p className="text-brand-primary-new text-center text-[14px] font-medium leading-normal tracking-[-0.14px]">
            {heading}
          </p>
          <p className="text-[#617390] text-center font-['Inter'] text-[12px] font-normal leading-normal">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoDataCard;
